import React, { Fragment } from 'react';
import { Card, Image } from 'semantic-ui-react';
import { string, func, number, arrayOf } from 'prop-types';

const LiveCard = ({
  as,
  to,
  image,
  header,
  meta,
  description,
  index,
  languageId,
  terms,
}) => {
  const localeString = languageId === 2 ? 'es' : 'en';
  const date = new Date(
    new Date(meta).getTime() + 5 * 60 * 60 * 1000
  ).toLocaleString(localeString, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  return (
    <Card
      as={as}
      to={to}
      raised={false}
      className={index === 0 ? 'latest' : ''}
    >
      <Card.Content>
        <div className="image-wrap">
          <Image floated="left" size="medium" src={image} />
          {index === 0 && (
            <Fragment>
              <div className="overlay-background" />
              <div className="overlay-text">{terms[4]}</div>
            </Fragment>
          )}
        </div>
        <Card.Header>{header}</Card.Header>
        <Card.Meta>{date}</Card.Meta>
        <Card.Description>{description.split('\n')[0]}</Card.Description>
      </Card.Content>
    </Card>
  );
};

LiveCard.propTypes = {
  as: func.isRequired,
  to: string.isRequired,
  image: string.isRequired,
  header: string.isRequired,
  meta: string.isRequired,
  description: string.isRequired,
  index: number.isRequired,
  languageId: number.isRequired,
  terms: arrayOf(string).isRequired,
};

export default LiveCard;



// WEBPACK FOOTER //
// ./src/components/Feed/LiveCard.jsx